import { FC, useContext } from "react";
import LayoutComponentProps from "./LayoutHeaderComponentProps";

const LayoutHeaderComponent: FC<LayoutComponentProps> = ({ title, open, setOpen }) => {
    const handleToggle = () => setOpen(!open);
    return <nav className="header">
        <div className="btn_open hover" onClick={handleToggle}>
            <img src="/assets/logo_white.png" alt="menu icon"  style={{height: 30}}/>
        </div>
        <div className="title">{title}</div>
    </nav>
}

export default LayoutHeaderComponent;